<template>
    <!-- "Explore Documents" — the searchable general-forms catalog (RAC-10324).
         Selecting a form starts a document interview by exact catalog name. -->
    <ModalJetstream :show="show" :max-width="'lg'" @close="$emit('close')">
        <div class="bg-white rounded-lg p-6 m-2">
            <div class="mb-4 flex items-start justify-between border-b pb-3">
                <div>
                    <h2 class="text-xl font-bold text-gray-800">General Documents</h2>
                    <p class="text-sm text-gray-500 mt-0.5">Included with your plan — pick a document to start drafting.</p>
                </div>
                <button class="text-gray-500 hover:text-gray-700 focus:outline-none" @click="$emit('close')">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
            </div>

            <input
                v-model="search"
                type="text"
                placeholder="Search documents…"
                class="block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 sm:text-sm mb-3"
            >

            <div class="max-h-96 overflow-y-auto space-y-2 pr-1">
                <button
                    v-for="form in filteredForms"
                    :key="form.name"
                    type="button"
                    class="w-full text-left rounded-lg border border-gray-300 px-4 py-3 text-sm font-medium text-gray-800 hover:border-rent-risk-blue-400 hover:bg-gray-50 transition-colors focus:outline-none"
                    @click="$emit('select', form.name)"
                >
                    {{ form.name }}
                </button>
                <p v-if="filteredForms.length === 0" class="text-sm text-gray-500 text-center py-6">
                    No documents match "{{ search }}".
                </p>
            </div>
        </div>
    </ModalJetstream>
</template>

<script setup>
import { computed, ref } from 'vue'
import ModalJetstream from '@/Jetstream/Modal.vue'

const props = defineProps({
    show: { type: Boolean, default: false },
    // [{name}] from tabData.document_catalog.
    forms: { type: Array, default: () => [] },
})

defineEmits(['close', 'select'])

const search = ref('')

const filteredForms = computed(() => {
    const term = search.value.trim().toLowerCase()
    if (term === '') {
        return props.forms
    }
    return props.forms.filter((form) => form.name.toLowerCase().includes(term))
})
</script>
